import axios from "axios";
const url = "https://demofashion.herokuapp.com/public";
export default axios.create({
    baseURL:url,
    withCredentials:true
});